//我的教室-学生端
import request from "@/config/_request";

//获得学员班级列表
export function stuGetStuClassList(params) {
  return request({
    url: "/api/stu/get/stu/class/list",
    params,
    method: "get"
  });
}

//获得学员讲次ID
export function stuGetStuTchPlanList(params) {
  return request({
    url: "/api/stu/get/stu/tch/plan/list",
    params,
    method: "get"
  });
}
//查询获得学员课程表
export function stuGetStuTimetable(params) {
  return request({
    url: "/api/stu/get/stu/timetable",
    params,
    method: "get"
  });
}

export function stuGetStuTimetableNew(params) {
  return request({
    url: "/api/stu/get/stu/timetable/new",
    params,
    method: "get"
  });
}
export function stuGetStuTimetableNewWithOutPageInfo(params) {
  return request({
    url: "/api/stu/getStuTimetableNewWithOutPageInfo",
    params,
    method: "get"
  });
}




//学员出勤记录
export function stuGetStuSignInfo(params) {
  return request({
    url: "/api/stu/get/stu/sign/info",
    params,
    method: "get"
  });
}

//学生获得课堂任务和课后作业作品
export function stuGetTchWorkList(params) {
  return request({
    url: "/api/stu/get/tch/work/list",
    params,
    method: "get"
  });
}

//学生端首页获得最新4个课堂作品
export function stuGetIndexTchWorkList(params) {
  return request({
    url: "/api/stu/get/index/tch/work/list",
    params,
    method: "get"
  });
}






//获得学生科目
export function stuGetStuSubjectAuth(params) {
  return request({
    url: "/api/stu/get/stu/subject/auth",
    params,
    method: "get"
  });
}

//查询班级同学自由创作作品
export function stuGetClassmateWorkList(params) {
  return request({
    url: "/api/stu/get/classmate/work/list",
    params,
    method: "get"
  });
}

//获得学生今日课程
export function stuGetStuTodayCourse(params) {
  return request({
    url: "/api/stu/get/stu/today/course",
    params,
    method: "get"
  });
}
//获得新的学生index页面数字统计信息
export function getStuIndexNumInfoForNew(params) {
  return request({
    url: "/api/stu/get/indexinfo/for/new",
    params,
    method: "get"
  });
}

